var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inputItemWrapper" },
    _vm._l(_vm.itemList, function (item) {
      return _c(
        "div",
        {
          key: item.value,
          staticClass: "inputItemInnerWrapper",
          class: {
            isPc: !_vm.isSp,
            isConfirmationScreenWrapper: _vm.isConfirmationScreen,
            flexAutoSecond: _vm.flexAutoNum === 2,
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.handleSelectValue,
                expression: "handleSelectValue",
              },
            ],
            staticClass: "inputItem",
            attrs: {
              id: item.value,
              type: "radio",
              name: _vm.questionId,
              disabled: _vm.disabled,
              autocomplete: "off",
            },
            domProps: {
              value: item.value,
              checked: _vm._q(_vm.handleSelectValue, item.value),
            },
            on: {
              change: function ($event) {
                _vm.handleSelectValue = item.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "inputItemLabel",
              class: {
                isPc: !_vm.isSp,
                disabled: _vm.disabled,
                isConfirmationScreen: _vm.isConfirmationScreen,
              },
              attrs: { for: item.value },
            },
            [_vm._v("\n      " + _vm._s(item.text || item.name) + "\n    ")]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }